<template>
  <div id="stockQuery" class="clearfix">
   
    <el-col>
      <el-form
        ref="form"
        style="width:100%"
        :inline="true"
        :model="form"
        :label-position="labelPosition"
      >
        <el-form-item style="margin-bottom:15px" class="hewidth">
          <el-select clearable v-model="form.warehouseType" placeholder="请选择仓库类型">
            <el-option
              v-for="(item,index) in wareArr"
              :label="item.paraName"
              :value="item.paraCode"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom:15px" class="hewidth">
          <el-select v-model="searchForm.belongDeptId" placeholder="门店" clearable>
            <el-option
              v-for="(item,index) in shopDataList"
              :label="item.attribute1"
              :value="item.deptId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom:15px" class="hewidth">
          <el-select clearable v-model="form.brandId" placeholder="品牌" @change="choseBrand">
            <el-option
              v-for="item,index in brandList"
              :key="index"
              :label="item.brandName"
              :value="item.brandId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom:15px" class="hewidth">
          <el-select clearable v-model="form.categoryId" placeholder="品类" @change="choseCategory">
            <el-option
              v-for="item,index in categoryList"
              :key="index"
              :label="item.categoryName"
              :value="item.categoryId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom:15px" class="hewidth">
          <el-select clearable v-model="form.modelId" placeholder="型号" @change="choseModel">
            <el-option
              v-for="item,index in modelList"
              :key="index"
              :label="item.modelName"
              :value="item.modelId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;" class="hewidth">
          <el-select clearable filterable v-model="searchForm.materialCoding" placeholder="物料">
            <el-option
              v-for="(item,index) in materialFormList"
              :key="index"
              :label="item.materialName"
              :value="item.materialCoding"
            >{{item.materialName}}</el-option>
          </el-select>
        </el-form-item>
        <div class="clearfix">
          <el-form-item style="margin-bottom:15px" class="hewidth">
            <el-input clearable v-model.trim="searchForm.materialCode" placeholder="物料编码"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:15px" class="hewidth">
            <el-input clearable v-model.trim="searchForm.materialName" placeholder="物料名称"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:15px" class="hewidth">
            <el-input clearable v-model.trim="searchForm.code" placeholder="序列号"></el-input>
          </el-form-item>
          <el-form-item style="width: 30%; margin-bottom: 15px;">
            <el-button type="primary" size="medium" @click="SubmitSearch('searchForm')">查询</el-button>
            <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            <el-button type="success"  size="small" @click="downLoad.exportExcel('tableId')">导出</el-button>
      <!-- <i
        class="el-icon-refresh"
        style="font-size: 25px;cursor: pointer;margin-left: 8px;"
        @click="refresh()"
      ></i> -->
          </el-form-item>
         <!--  <el-form-item  style="width: 22%; margin-bottom: 15px;" >
          <el-col class="clearfix"  style="text-align:right">
               
             </el-col>
           </el-form-item> -->
        </div>
      </el-form>
    </el-col>

    <el-card class="box-card" style="width: 100%">
      <el-table
        v-loading="loading1"
        :data="returnData"
        border
        :header-cell-style="{'text-align':'center'}"
        :summary-method="getSummaries"
        show-summary
        id="tableId"
        style="width: 100%"
      >
        <el-table-column align="center" type="index" width="50" label="序号"></el-table-column>
        <el-table-column align="center" prop="materialCode" width="105" label="物料编号"></el-table-column>
        <el-table-column align="center" prop="modelName"width="110" label="型号"></el-table-column>
        <el-table-column align="center" width="230" prop="materialName" label="物料名称"></el-table-column>
        <el-table-column align="center" prop="warehouseName" width="110" label="所在仓库"></el-table-column>
        <el-table-column align="center" prop="warehouseType" label="仓库类型">
          <template
            slot-scope="scope"
          >{{scope.row.warehouseType | sysCodeFileter('warehouse_type')}}</template>
        </el-table-column>
        <el-table-column align="center" prop="inventoryATotal" label="库存总量"></el-table-column>
        <el-table-column align="center" prop="broughtTotal" label="已领数量"></el-table-column>
        <el-table-column align="center" prop="UsefulNumber" label="可用数量"></el-table-column>
        <el-table-column align="center" prop="freezeTotal" label="冻结数量"></el-table-column>
        <el-table-column align="center" prop="sumPrice" label="库存价值"></el-table-column>
        <el-table-column align="center" label="操作" v-if="basicsAuth.all_serial_number">
          <template slot-scope="scope">
            <el-button
              @click="showSerialNumber(scope.row.materialCoding,null,null,0,scope.row.warehouseType)"
              type="text"
              size="small"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100,500,1000]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next,jumper"
            :total="pages.total"
          ></el-pagination>
        </div>
      </el-col>
    </el-card>
    <!-- 查看序列号弹出框 -->
    <el-dialog class="dialog-content-self" title="序列号类型" :visible.sync="dialogTableVisible">
      <el-row class="table-filter-content">
        <el-button :class="{active:shift==0}" @click="handleShift(0)">全部序列号</el-button>
        <el-button :class="{active:shift==1}" @click="handleShift(1)">可用序列号</el-button>
        <el-button :class="{active:shift==2}" @click="handleShift(2)">已领序列号</el-button>
        <el-button :class="{active:shift==3}" @click="handleShift(3)">冻结序列号</el-button>
      </el-row>
      <el-row
        class="dialog-code-content"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-col v-for="(item,index) in codeList" :key="index" :span="6">
          <p>{{item.code}}</p>
        </el-col>
      </el-row>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleNumberSizeChange"
            @current-change="handleNumberCurrentChange"
            :current-page="numberPages.page"
            :page-sizes="[10, 20, 50,]"
            :page-size="numberPages.pageSize"
            layout="total, sizes, prev, pager, next,jumper"
            :total="numberPages.total"
          ></el-pagination>
        </div>
      </el-col>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store/store";
import ip from "@/config/ip.js";
import {
  inventoryList,
  inventorySerial,
  selectParameterInfoBusiness,
  selectMaterialClassifications,
  selectAllBrand,
  selectCategory,
  selectModel,
  shopList,
  selectMaterialManagements
} from "../../api/api";
import { getPermission } from "../../api/authRequest";
export default {
  name: "stockQuery",
  data() {
    const validateNumber = (rule, value, callback) => {
      if (/^[1-9]\d*|0$/.test(value) == false) {
        callback(new Error("请输入一个大于0的整数"));
      } else {
        callback();
      }
    };
    return {
      form: {
        brandId: "", //品牌ID
        categoryId: "", //品类ID
        modelId: "", //型号ID
        warehouseType: "LPC", //仓库
        classificationId: "" //物料分类ID
      },
      labelPosition: "left",
      //分页变量
      pages: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      materialFormList: [],
      activeIndex: 0, //选择仓库下标
      selectIndex: 0, //选择物料下标
      wareArr: [], //仓库数组
      MaterialArr: [], //物料数组
      searchForm: {
        materialCode: "", //物料编码
        materialName: "",
        belongDeptId: "",
        code: "", //序列号
        materialCoding: "",
        materialCode: ""
      },
      returnData: [], //表格数组
      dialogTableVisible: false, //弹出框
      shift: 0,
      shopDataList: [],
      codeList: [], //序列号数组
      loading: false, //加载状态
      loading1: false, //加载状态
      loading2: false, //加载状态
      materialCoding: "", //查看序列号参数
      warehouseType: "",
      brandList: [], //品牌数组
      categoryList: [], //品类数组
      modelList: [], //型号数组
      //分页变量
      numberPages: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      basicsAuth: {
        all_serial_number: false
      }
    };
  },
  components: {},
  created() {
    this.getShopList();
    this.getStockType(); //请求仓库类型数据
    this.getMaterialList(); //请求物料类型数据
    this.getBrandList(); //请求机型品牌数据
  },
  mounted() {
    this.basicsAuth.all_serial_number = getPermission(
      "/api/inventory/all_serial_number"
    );
  },
  methods: {
    clearFrom() {
      this.form.brandId = "";
      this.form.categoryId = "";
      this.form.modelId = "";
      this.searchForm.materialCoding = "";
      this.form.warehouseType = "LPC";
      this.form.classificationId = "";
      this.searchForm.materialCode = "";
      this.searchForm.materialName = "";
      this.searchForm.code = "";
      this.getInventoryList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getInventoryList();
    },
    handleCurrentChange(Page) {
      this.pages.page = Page;
      this.getInventoryList();
    },
    handleNumberSizeChange(val) {
      this.numberPages.pageSize = val;
      this.handleShift(this.shift);
    },
    handleNumberCurrentChange(Page) {
      this.numberPages.page = Page;
      this.handleShift(this.shift);
    },
    //导出
    exportWarehouseList() {
      console.log(222)
      let para = {
        materialCode: this.searchForm.materialCode,
        materialName: this.searchForm.materialName,
        code: this.searchForm.code,
        startRow: this.pages.page,
        pageSize: this.pages.pageSize,
        ware: this.form.warehouseType,
        brandId: this.form.brandId,
        categoryId: this.form.categoryId,
        modelId: this.form.modelId,
        classificationId: this.form.classificationId
      };
      axios({
        url: `${ip.Ips.ip1}/api/export/export_warehouse`,
        method: "post",
        headers: {
          token: `${store.state.token}`
        },
        data: para,
        responseType: "blob"
      })
        .then(res => {
          console.log(res)
          let fileName = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename=")[1];
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob);
            downloadElement.href = href;
            downloadElement.download = fileName;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //获取门店列表
    getShopList() {
      let para = {
        startRow: 1,
        pageSize: 10000
      };
      shopList(para)
        .then(res => {
          if (res.data.status == 100) {
            this.shopDataList = res.data.results.list;
            this.searchForm.belongDeptId =
              this.shopDataList.length > 0 ? this.shopDataList[0].deptId : "";
            this.getInventoryList(); //请求库存数据
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    handleShift(num) {
      this.numberPages.startRow = 1;
      if (num == 0) {
        this.showSerialNumber(
          this.materialCoding,
          null,
          null,
          num,
          this.warehouseType
        );
      } else if (num == 1) {
        this.showSerialNumber(
          this.materialCoding,
          0,
          1,
          num,
          this.warehouseType
        );
      } else if (num == 2) {
        this.showSerialNumber(
          this.materialCoding,
          1,
          null,
          num,
          this.warehouseType
        );
      } else {
        this.showSerialNumber(
          this.materialCoding,
          null,
          2,
          num,
          this.warehouseType
        );
      }
    },
    choseBrand(e) {
      this.getCategoryList();
    },
    choseCategory(e) {
      this.getModelList();
    },
    choseModel() {
      this.getMateriaList();
    },
    //机型型号
    getModelList() {
      this.form.modelId = "";
      let para = {
        brandId: this.form.brandId,
        categoryId: this.form.categoryId
      };
      selectModel(para)
        .then(res => {
          if (res.data.status == 100) {
            this.modelList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //机型品类
    getCategoryList() {
      this.form.categoryId = "";
      this.form.modelId = "";
      this.categoryList = [];
      this.modelList = []; //清空型号数据
      let para = {
        brandId: this.form.brandId
      };
      selectCategory(para)
        .then(res => {
          if (res.data.status == 100) {
            this.categoryList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //机型品牌
    getBrandList() {
      selectAllBrand()
        .then(res => {
          if (res.data.status == 100) {
            this.brandList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //机型物料
    getMateriaList() {
      this.searchForm.materialCoding = "";
      this.searchForm.materialCode = "";
      let para = {
        brandId: this.form.brandId,
        categoryId: this.form.categoryId,
        modelId: this.form.modelId,
        colorId: this.form.colorId,
        startRow: 1,
        pageSize: 1000
      };
      selectMaterialManagements(para)
        .then(res => {
          if (res.data.status == 100) {
            this.materialFormList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //仓库
    getStockType() {
      let para = {
        paraType: "warehouse_type"
      };
      selectParameterInfoBusiness(para)
        .then(res => {
          if (res.data.status == 100) {
            let obj = {
              paraName: "全部",
              paraCode: ""
            };
            this.wareArr = res.data.results.list;
            this.wareArr.push(obj);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //物料分类
    getMaterialList() {
      this.loading2 = true;
      let para = {};
      selectMaterialClassifications(para)
        .then(res => {
          if (res.data.status == 100) {
            let obj = {
              classificationName: "全部",
              classificationId: ""
            };
            this.MaterialArr = res.data.results;
            this.MaterialArr.unshift(obj);
            this.loading2 = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
            this.loading2 = false;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
          this.loading2 = false;
        });
    },
    ///查询物料分类
    getInventoryList() {
      this.loading1 = true;
      let para = {
        materialCode: this.searchForm.materialCode, //物料编码
        materialName: this.searchForm.materialName,
        belongDeptId: this.searchForm.belongDeptId,
        code: this.searchForm.code, //物料序号
        startRow: this.pages.page, //当前页码
        pageSize: this.pages.pageSize, //每页条数
        ware: this.form.warehouseType, //仓库
        brandId: this.form.brandId, //品牌
        categoryId: this.form.categoryId, //品类
        modelId: this.form.modelId, //型号
        classificationId: this.form.classificationId, //物料类型
        materialCoding:this.searchForm.materialCoding
      };
      inventoryList(para)
        .then(res => {
          if (res.data.status == 100) {
            this.returnData = res.data.results.list;
            this.pages.total = res.data.results.total;
            this.returnData.forEach((item, index) => {
              this.returnData[index].UsefulNumber = (
                item.inventoryATotal -
                item.broughtTotal -
                item.freezeTotal
              ).toFixed(0);
              this.returnData[index].storePrice = (
                item.inventoryATotal * item.price
              ).toFixed(0);
            });
            this.loading1 = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
            this.loading1 = false;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
          this.loading1 = false;
        });
    },
    //查看序列号
    showSerialNumber(
      materialCoding,
      affiliationType,
      status,
      num,
      warehouseType
    ) {
      this.codeList = []; //清空数据
      this.dialogTableVisible = true;
      this.loading = true;
      this.shift = num;
      this.materialCoding = materialCoding;
      this.warehouseType = warehouseType;
      let para = {
        materialCoding: this.materialCoding,
        warehouseType: this.warehouseType,
        state: num == 0 ? null : 1,
        status: status,
        code: this.searchForm.code,
        affiliationType: affiliationType,
        startRow: this.numberPages.page,
        pageSize: this.numberPages.pageSize
      };
      inventorySerial(para)
        .then(res => {
          console.log(res.data.results);
          if (res.data.status == 100) {
            this.numberPages.total = res.data.results.total;
            this.codeList = res.data.results.list;
            this.loading = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //清空刷新
    refresh() {
      this.form = {};
      this.searchForm = {};
      this.getInventoryList();
    },
    //确认检索
    SubmitSearch() {
        console.log(222,"ttttt")
      this.getInventoryList();
    },
    //选择仓库类型
    selectStockFn(num, item) {
      this.activeIndex = num;
      this.form.warehouseType = item.paraCode;
    },
    //选择物料类型
    selectMaterialFn(x, item) {
      this.selectIndex = x;
      this.form.classificationId = item.classificationId;
    },
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index < 5) {
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });
      return sums.toFixed(2);
    }
  },
  computed: {},
  watch: {}
};
</script>
<style lang="scss" type="text/css" scoped>
.headerT {
  margin: 10px 0 20px;
}
#stockQuery {
  padding-top: 10px;
}
.dialog-content-self {
  el-table {
    el-table-column {
      th,
      tr {
        text-align: center !important;
      }
    }
  }
  .table-filter-content {
    margin-bottom: 20px;
    margin-top: -20px;
  }
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.active {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.dialog-code-content {
  text-align: center;
  border: 1px solid #e3e3e3;
  min-height: 500px;
  .el-col {
    border: 1px solid #f4f4f4;
    line-height: 40px;
  }
}
 .hewidth {
        width: 15% !important;
      }
</style>



// WEBPACK FOOTER //
// stockQueryManage.vue?4a9466b8